// @flow

import React from 'react';
import { ImportantNotice } from 'trpc-react-native-ui';

import I18n from '../../../lib/i18n';
import FormatService from '../../../lib/format';
import { dateUtils, getRenewalDate } from '../../../lib/date-utils';

export type StateProps = {
  balance: ?number,
};

type Props = {
  timestamp: string,
};

export const WalletForfeitureCountdown = ({ balance, timestamp }: Props & StateProps) => {
  const timestampToUse = Number(timestamp);
  const remainingTime = getRenewalDate(timestampToUse, true);

  const walletAmount = balance && FormatService.formatCentsToCurrency(balance, true);

  const forfeitedDate = dateUtils.format(timestampToUse).split(',');
  const forfeitedDay = forfeitedDate[0];
  const forfeitedHour = forfeitedDate[1].trim();

  const walletForfeitureText = I18n.t('Dashboard.MyWallet.walletForfeiture.text', {
    forfeitedDay,
    forfeitedHour,
    remainingTime,
    walletAmount,
  });

  return <ImportantNotice emphasizedText={walletForfeitureText} />;
};
